import { render, staticRenderFns } from "./Posters.vue?vue&type=template&id=9b1459b2&"
import script from "./Posters.vue?vue&type=script&lang=js&"
export * from "./Posters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QSpace,QBtn,QSeparator,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QSpace,QBtn,QSeparator,QTable,QTd})
